"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INFORMATION_COLORS_GRID = exports.BACKGROUND_COLORS = void 0;
var colors_1 = require("./colors");
var INFORMATION_COLORS_GRID = [
    { label: 'Semantic/info 25', color: colors_1.tannerSemantic['info']['25'] },
    { label: 'Semantic/error 25', color: colors_1.tannerSemantic['error']['25'] },
    { label: 'Semantic/warning 25', color: colors_1.tannerSemantic['warning']['25'] },
    { label: 'Semantic/success 25', color: colors_1.tannerSemantic['success']['25'] },
    { label: 'Semantic/info 50', color: colors_1.tannerSemantic['info']['50'] },
    { label: 'Semantic/error 50', color: colors_1.tannerSemantic['error']['50'] },
    { label: 'Semantic/warning 50', color: colors_1.tannerSemantic['warning']['50'] },
    { label: 'Semantic/success 50', color: colors_1.tannerSemantic['success']['50'] },
    { label: 'Semantic/info 100', color: colors_1.tannerSemantic['info']['100'] },
    { label: 'Semantic/error 100', color: colors_1.tannerSemantic['error']['100'] },
    { label: 'Semantic/warning 100', color: colors_1.tannerSemantic['warning']['100'] },
    { label: 'Semantic/success 100', color: colors_1.tannerSemantic['success']['100'] },
    { label: 'Semantic/info 200', color: colors_1.tannerSemantic['info']['200'] },
    { label: 'Semantic/error 200', color: colors_1.tannerSemantic['error']['200'] },
    { label: 'Semantic/warning 200', color: colors_1.tannerSemantic['warning']['200'] },
    { label: 'Semantic/success 200', color: colors_1.tannerSemantic['success']['200'] },
    { label: 'Semantic/info 300', color: colors_1.tannerSemantic['info']['300'] },
    { label: 'Semantic/error 300', color: colors_1.tannerSemantic['error']['300'] },
    { label: 'Semantic/warning 300', color: colors_1.tannerSemantic['warning']['300'] },
    { label: 'Semantic/success 300', color: colors_1.tannerSemantic['success']['300'] },
    { label: 'Semantic/info 400', color: colors_1.tannerSemantic['info']['400'] },
    { label: 'Semantic/error 400', color: colors_1.tannerSemantic['error']['400'] },
    { label: 'Semantic/warning 400', color: colors_1.tannerSemantic['warning']['400'] },
    { label: 'Semantic/success 400', color: colors_1.tannerSemantic['success']['400'] },
    { label: 'Semantic/info 500', color: colors_1.tannerSemantic['info'].color },
    { label: 'Semantic/error 500', color: colors_1.tannerSemantic['error'].color },
    { label: 'Semantic/warning 500', color: colors_1.tannerSemantic['warning'].color },
    { label: 'Semantic/success 500', color: colors_1.tannerSemantic['success'].color },
    { label: 'Semantic/info 600', color: colors_1.tannerSemantic['info']['600'] },
    { label: 'Semantic/error 600', color: colors_1.tannerSemantic['error']['600'] },
    { label: 'Semantic/warning 600', color: colors_1.tannerSemantic['warning']['600'] },
    { label: 'Semantic/success 600', color: colors_1.tannerSemantic['success']['600'] },
    { label: 'Semantic/info 700', color: colors_1.tannerSemantic['info']['700'] },
    { label: 'Semantic/error 700', color: colors_1.tannerSemantic['error']['700'] },
    { label: 'Semantic/warning 700', color: colors_1.tannerSemantic['warning']['700'] },
    { label: 'Semantic/success 700', color: colors_1.tannerSemantic['success']['700'] },
    { label: 'Semantic/info 800', color: colors_1.tannerSemantic['info']['800'] },
    { label: 'Semantic/error 800', color: colors_1.tannerSemantic['error']['800'] },
    { label: 'Semantic/warning 800', color: colors_1.tannerSemantic['warning']['800'] },
    { label: 'Semantic/success 800', color: colors_1.tannerSemantic['success']['800'] },
    { label: 'Semantic/info 900', color: colors_1.tannerSemantic['info']['900'] },
    { label: 'Semantic/error 900', color: colors_1.tannerSemantic['error']['900'] },
    { label: 'Semantic/warning 900', color: colors_1.tannerSemantic['warning']['900'] },
    { label: 'Semantic/success 900', color: colors_1.tannerSemantic['success']['900'] },
    { label: 'Semantic/info 1000', color: colors_1.tannerSemantic['info']['1000'] },
    { label: 'Semantic/error 1000', color: colors_1.tannerSemantic['error']['1000'] },
    { label: 'Semantic/warning 1000', color: colors_1.tannerSemantic['warning']['1000'] },
    { label: 'Semantic/success 1000', color: colors_1.tannerSemantic['success']['1000'] },
];
exports.INFORMATION_COLORS_GRID = INFORMATION_COLORS_GRID;
var BACKGROUND_COLORS = [
    {
        label: 'Semantic/info/background (info/50)',
        color: colors_1.tannerSemantic['info']['50'],
    },
    {
        label: 'Semantic/error/background (error/50)',
        color: colors_1.tannerSemantic['error']['50'],
    },
    {
        label: 'Semantic/warning/background (warning/50)',
        color: colors_1.tannerSemantic['warning']['50'],
    },
    {
        label: 'Semantic/success/background (success/50)',
        color: colors_1.tannerSemantic['success']['50'],
    },
    {
        label: 'Semantic/info/color (info/500)',
        color: colors_1.tannerSemantic['info']['500'],
    },
    {
        label: 'Semantic/error/color (error/500)',
        color: colors_1.tannerSemantic['error']['500'],
    },
    {
        label: 'Semantic/warning/color (warning/500)',
        color: colors_1.tannerSemantic['warning']['500'],
    },
    {
        label: 'Semantic/success/color (success/500)',
        color: colors_1.tannerSemantic['success']['500'],
    },
];
exports.BACKGROUND_COLORS = BACKGROUND_COLORS;
//# sourceMappingURL=constants.js.map